import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: 2.4,
    color: theme.colors.black,
  },
  subTitle: {
    fontSize: 16,
    lineHeight: 1.5,
    color: theme.colors.black30,
  },
  searchImage: {
    marginBottom: 37,
  },
  wrapper: {
    // marginTop: 112,
    maxWidth: 480,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));

export default useStyles;
